// Registry central dos tipos de componente do tema (lado loja).
//
// Espelha o registry admin em html/pages/b2b/componentes/js/component-types.js.
// Handlers do tema-preview-listener são type-agnostic: consultam este registry
// pra achar merge customizado por tipo (se existir) e delegam. Sem merge, o
// handler faz shallow-spread padrão do payload sobre o componente atual.
//
// Adicionar um tipo 10 = adicionar uma entrada aqui + criar/registrar o
// componente Vue. Nenhum outro arquivo precisa mudar.

export const TEMA_TYPES = {
  1: { nome: "Slider" },
  2: { nome: "Mini Slider" },
  3: { nome: "Banner Triplo" },
  4: { nome: "Banner Wide" },
  5: { nome: "Slider Categorias" },
  6: { nome: "Produtos em Destaque" },
  7: { nome: "Banner Duplo" },
  8: { nome: "Categorias" },
  9: { nome: "HTML Custom" },
  10: { nome: "Pop-Up" },
  11: { nome: "Layout Personalizado" },
  12: { nome: "Banner Flexível" },
};

// Se um tipo quiser lógica de merge custom (ex: concatenar arrays em vez
// de substituir), expõe merge(current, payload) → objeto merged.
// Por default o handler faz { ...current, ...payload }.
export function getTypeMerge(tipo) {
  const def = TEMA_TYPES[Number(tipo)];
  if (def && typeof def.merge === "function") return def.merge;
  return null;
}
